import React from "react";
import dynamic from "next/dynamic";
import { getInitialData } from "../../service/apiFetch";
import NotFound from "../../components/ErrorPage/NotFound";
import Main from "../../components/Pageblock/Main";
import MetaTags from "../../components/Head/MetaTags";

const PhotoMain = dynamic(() => import("../../components/Photo/PhotoMain"));
const VideoMain = dynamic(() => import("../../components/Video/VideoMain"));
const DownlMain = dynamic(() => import("../../components/Download/DownlMain"));
const SliderMain = dynamic(() => import("../../components/Slider/SliderMain"));
const ListMain = dynamic(() => import("../../components/List/ListMain"));
const FaqMain = dynamic(() => import("../../components/Faq/FaqMain"));
const TestMain = dynamic(() => import("../../components/Testimonial/TestMain"));
const CourseMain = dynamic(() => import("../../components/Course/CourseMain"));
const BlogMain = dynamic(() => import("../../components/Blogdesign/BlogMain"));
const DynamicForm = dynamic(() => import("../../components/utils/DynamicForm"));

export const getStaticPaths = async () => ({
  paths: [],
  fallback: "blocking",
});

export const getStaticProps = async (context) => {
  const { uri1 } = context.params;
  const initialData = await getInitialData(uri1);

  return {
    props: {
      websiteData: initialData?.websiteData || {},
      pageData: initialData?.data || {},
      title: initialData?.title,
      metaTags: initialData?.metaTags || {},
      url: initialData?.url || "",
      error: initialData?.error || "",
    },
  };
};

const DynamicPage = ({ pageData }) => {
  if (pageData?.error) {
    return (
      <div>
        <MetaTags title={pageData?.details?.error?.message} />
        <NotFound
          errorCode={pageData?.details?.statusCode}
          errorType={pageData?.details?.error?.message}
        />
      </div>
    );
  }

  const contentBlocks = pageData?.contentBlock;

  return (
    <div>
      <MetaTags
        title={pageData?.pageData?.metaTags?.ogTitle}
        keywords={pageData?.pageData?.metaTags?.keywords}
        description={pageData?.pageData?.metaTags?.ogDescription}
        image={pageData?.pageData?.metaTags?.ogImage}
        url={pageData?.pageData?.url || undefined}
      />

      {Array.isArray(contentBlocks) &&
        contentBlocks.map((item, index) => {
          const type = item?.advanceData?.type;

          return (
            <div key={index}>
              <Main basicData={item} />

              {type === "PHOTO" && <PhotoMain data={item} />}
              {type === "VIDEO" && <VideoMain data={item} />}
              {type === "DOWNLOAD" && <DownlMain data={item} />}
              {type === "SLIDER" && <SliderMain data={item} />}
              {type === "LIST" && <ListMain data={item} />}
              {type === "FAQ" && <FaqMain data={item} />}
              {type === "TESTIMONIAL" && <TestMain data={item} />}
              {type === "COURSE" && <CourseMain data={item} />}
              {type === "FORM" && (
                <DynamicForm
                  data={item?.advanceData}
                  customParamsData={pageData?.pageData?.customParams}
                />
              )}
              {type === "BLOG" && <BlogMain data={item} />}
            </div>
          );
        })}
    </div>
  );
};

export default DynamicPage;
